
// Storage keys for local storage
export const JOURNEYS_STORAGE_KEY = "saved_journey_maps";
export const FOLDERS_STORAGE_KEY = "journey_map_folders";
